import { makeStyles } from 'tss-react/mui';

export type WaveBgProps = {
  headerClass?: string;
  color?: 'primary' | 'secondary' | 'blue' | 'no-background';
};

export const WaveBg: React.FC<WaveBgProps> = ({ color, headerClass }) => {
  const { classes, cx } = useWaveStyles();

  return (
    <div className={classes.root}>
      {headerClass && <div className={headerClass} />}
      <div
        className={cx(classes.wave, {
          [classes.wavePrimary]: color === 'primary',
          [classes.waveBlue]: color === 'blue',
          [classes.waveNoBackground]: color === 'no-background'
        })}
      />
    </div>
  );
};

const useWaveStyles = makeStyles({ name: 'Wave' })(theme => ({
  root: {},
  wave: {
    backgroundImage: 'url(assets/images/repeatable-wave-secondary.svg)',
    height: '38px',
    width: '100%',
    backgroundSize: 'contain',
    backgroundRepeat: 'repeat-x',

    [theme.breakpoints.up('sm')]: {
      height: '56px'
    }
  },
  wavePrimary: {
    backgroundImage: 'url(assets/images/repeatable-wave-primary.svg)',
  },
  waveBlue: {
    backgroundImage: 'url(assets/images/repeatable-wave-blue.svg)',
  },
  waveNoBackground: {
    backgroundImage: 'url(assets/images/repeatable-wave-no-background.svg)',
  }
}));
